import { LANGS, LANG_LABELS, commonT, getLang, setLang } from '@/i18n';
import { cn } from '@/lib/utils';

/// Seletor `PT · EN · ES`, o mesmo formato do rodapé da landing.
///
/// Trocar recarrega a página (ver `i18n/core.ts`), então ele mora em tela de
/// entrada e de leitura (login, lista de eventos, inscrição, páginas
/// públicas) e NÃO no wizard nem no painel ao vivo, onde recarregar jogaria
/// fora formulário não salvo ou o estado da prova na tela. A escolha é
/// lembrada e vale pra todas as telas.
///
/// Cada opção leva o nome no próprio idioma no `title` e o `lang` certo, pra
/// leitor de tela pronunciar "English" em inglês.
export function LanguageSelect({ className }: { className?: string }) {
  const current = getLang();
  return (
    <nav aria-label={commonT().language} className={cn('flex items-center gap-1 text-xs', className)}>
      {LANGS.map((lang, i) => (
        <span key={lang} className="flex items-center gap-1">
          {i > 0 && <span aria-hidden="true" className="opacity-50">·</span>}
          <button
            type="button"
            lang={lang}
            title={LANG_LABELS[lang]}
            aria-current={lang === current ? 'true' : undefined}
            onClick={() => lang !== current && setLang(lang)}
            className={cn(
              'rounded px-1 py-0.5 uppercase tracking-wide transition-opacity',
              lang === current ? 'font-semibold' : 'opacity-60 hover:opacity-100',
            )}
          >
            {lang}
          </button>
        </span>
      ))}
    </nav>
  );
}
